import { DefaultError, useMutation } from "@tanstack/react-query";
import { PageModuleDataToUpdate } from "entities/pages/types";
import { updateSettingModule } from "../api/updateSettingModule";
import { invalidateModuleListByBrandSettingQuery } from "../queries/useModuleListByBrandSettingQuery";
import { invalidateSettingModuleDetails } from "../queries/useSettingModuleDetailsQuery";
import { invalidateSettingsListByBrandsQuery } from "../queries/useSettingsListByBrandQuery";

type Params = {
  moduleId: string;
  moduleData: PageModuleDataToUpdate;
  brandId: string;
  settingId: string;
};

export const useUpdateSettingModuleMutation = () => {
  return useMutation<void, DefaultError, Params>({
    mutationFn: async (params) => {
      await updateSettingModule(params);
    },
    onSuccess: (_, { brandId, settingId, moduleId }) => {
      invalidateSettingModuleDetails({ brandId, settingId, moduleId });
      invalidateModuleListByBrandSettingQuery(brandId, settingId);

      // invalidate query in 3 seconds
      setTimeout(() => {
        invalidateSettingsListByBrandsQuery(brandId);
      }, 3000);
    },
    onError: (e) => {
      console.error("Error occurred when creating module", e);
    },
  });
};
